import React from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

import PrivateRoute from "./components/privateRoute";
import Unauthorized from "./pages/unauthorized";

import WebP from "./pages/0.web_page_home";
import LogIn from "./pages/0.login";
import Hardware from "./pages/hardware";
import Home from "./pages/1.home"
import ListM from "./pages/2.list2"
import Operations from "./pages/3.operations";
import ListP from "./pages/5.products1";
import NewP from "./pages/new_prod";
import NewProdForm from "./components/newProdForm";
import ListB from "./pages/6.batches";
import ListB3 from "./pages/6.batchesDetail";
import BatchList3 from "./components/batchList3";
import BatchListRep from "./components/batchList4";
import BatchesReportPage from "./pages/6.batches_report";
import EditBatchForm from "./components/editBatchForm";
import ListShift from "./pages/shifts";
import NewShift from "./pages/new_shift";
import EditShiftForm from "./components/editShiftform";
import EditProdForm from "./components/editProdForm";
import ListB2 from "./pages/batchRep";
import ShiftReport from "./pages/shift_report";
import NewOper from "./pages/new_operator";
import BatchesTempPage from "./pages/6.batches_temp";
import NewBatchTempForm from "./components/newBachTempForm";
import Oee1 from "./pages/oee_rep";
import ActivityTypeRep from "./pages/activity_type_rep";
import Screen1 from "./pages/screen1";
import ScreenTotal from "./pages/screen_total";
import HelpCenter from "./pages/help";


// Activity Types
import ListActivityType from "./pages/activityType";
import NewActType from "./components/newActType";
//Activity List

import ActivityList from "./pages/activityList";
import NewActL from "./pages/new_act";
import EditActForm from "./components/editActForm";
import ActivityList1 from "./components/activityList1";
import ActivityOperReport from "./pages/activity_report";

// Operators
import OperatorL1 from "./pages/operator_list";


import Footer from "./components/footer"
import ProdList1 from "./components/prodlist";
import NewBatch from "./pages/new_batch";





//v2
function App() {
  return (
    <>
      <Router>
        <div>
          <Routes>
            <Route path="/" element={<WebP />} />
            <Route path="/0.login" element={<LogIn />} />
            <Route path="/unauthorized" element={<Unauthorized />} />

            <Route path="/1.home" element={
              <PrivateRoute allowedRoles={["Coder", "Administrator", "Operator", "Instalator"]}>
                <Home />
              </PrivateRoute>
            } />

            <Route path="/2.list2" element={
              <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                <ListM />
              </PrivateRoute>
            } />

            <Route path="/operations/:machineId" element={
              <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                <Operations />
              </PrivateRoute>
            } />

            <Route path="/5.products1" element={
              <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                <ListP />
              </PrivateRoute>
            } />

            <Route path="/new_prod" element={
              <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                <NewP />
              </PrivateRoute>
            } />


            {/* BATCHES TEMP------------------------------------------------------------*/}

            <Route
              path="/6.batches_temp"
              element={
                <PrivateRoute allowedRoles={["Operator", "Coder", "Administrator"]}>
                  <BatchesTempPage />
                </PrivateRoute>
              }
            />

            <Route
              path="/new_batch_temp"
              element={
                <PrivateRoute allowedRoles={["Operator", "Coder", "Administrator"]}>
                  <NewBatchTempForm />
                </PrivateRoute>
              }
            />

            <Route
              path="/edit_batch_temp/:id"
              element={
                <PrivateRoute allowedRoles={["Operator", "Coder", "Administrator"]}>
                  <NewBatchTempForm />
                </PrivateRoute>
              }
            />




            {/* BATCHES ------------------------------------------------------------*/}


            <Route path="/6.batches" element={
              <PrivateRoute allowedRoles={["Coder", "Administrator", "Operator"]}>
                <ListB />
              </PrivateRoute>
            } />

            <Route path="/new_batch" element={
              <PrivateRoute allowedRoles={["Operator", "Coder", "Administrator"]}>
                <NewBatch />
              </PrivateRoute>
            } />

            <Route path="/6.batchesDetail" element={
              <PrivateRoute allowedRoles={["Coder", "Administrator", "Operator"]}>
                <ListB3 />
              </PrivateRoute>
            } />

            <Route path="/batchList3/:id_c/:id_batch/:id_prod" element={
              <PrivateRoute allowedRoles={["Coder", "Administrator", "Operator"]}>
                <BatchList3 />
              </PrivateRoute>
            } />

            <Route path="/6.batches_report" element={
              <PrivateRoute allowedRoles={["Coder", "Administrator", "Operator"]}>
                <BatchesReportPage />
              </PrivateRoute>
            } />

            <Route path="/batchRep" element={
              <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                <ListB2 />
              </PrivateRoute>
            } />

            {/*EDIT BATCHES*/}

            <Route path="/edit_batch/:id" element={
              <PrivateRoute allowedRoles={["Coder", "Administrator", "Operator"]}>
                <EditBatchForm />
              </PrivateRoute>
            } />









            <Route path="/hardware" element={
              <PrivateRoute allowedRoles={["Coder", "Instalator"]}>
                <Hardware />
              </PrivateRoute>
            } />


            <Route path="/shifts" element={
              <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                <ListShift />
              </PrivateRoute>
            } />

            <Route path="/new_shift" element={
              <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                <NewShift />
              </PrivateRoute>
            } />

            <Route path="/shifts/:id_shift/edit" element={
              <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                <EditShiftForm />
              </PrivateRoute>
            } />

            {/* ===== Activity Types ===== */}
            {/* Lista */}
            <Route
              path="/activity-types"
              element={
                <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                  <ListActivityType />
                </PrivateRoute>
              }
            />
            {/* Crear nuevo */}
            <Route
              path="/activity-types/new"
              element={
                <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                  <NewActType />
                </PrivateRoute>
              }
            />
            {/* Editar existente */}
            <Route
              path="/activity-types/:id_activity/edit"
              element={
                <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                  <NewActType />
                </PrivateRoute>
              }
            />
            {/* Compatibilidad con la ruta antigua */}
            <Route path="/activityType" element={<Navigate to="/activity-types" replace />} />


            <Route path="/edit_prod/:id_prod" element={<EditProdForm />} />


            {/* ===== Activity List ==-------------------------------------------=== */}
            {/* Lista */}
            <Route
              path="/activityList"
              element={
                <PrivateRoute allowedRoles={["Coder", "Administrator", "Operator"]}>
                  <ActivityList />
                </PrivateRoute>
              }
            />
            {/* New Activity List*/}
            <Route
              path="/new_activity"
              element={
                <PrivateRoute allowedRoles={["Coder", "Administrator", "Operator"]}>
                  <NewActL />
                </PrivateRoute>
              }
            />
            {/* Activity Operator Report*/}
            <Route
              path="/activity_report"
              element={
                <PrivateRoute allowedRoles={["Coder", "Administrator", "Operator"]}>
                  <ActivityOperReport />
                </PrivateRoute>
              }
            />



            {/* Ruta para la página de edición de actividad */}
            <Route path="/edit_activity/:id" element={<EditActForm />} />


            <Route path="/activity_list" element={<ActivityList1 />} />
            {/* <Route path="/edit_activity/:id" element={<EditActForm />} /> */} {/* Aquí está la ruta con el parámetro 'id' */}







            {/* ---------------------Operators List-----------------------*/}
            <Route
              path="/operator-list"
              element={
                <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                  <OperatorL1 />
                </PrivateRoute>
              }
            />

            <Route
              path="/new_operator"
              element={
                <PrivateRoute allowedRoles={["Coder", "Administrator", "Operator"]}>
                  <NewOper />  {/* mismo form en modo creación */}
                </PrivateRoute>
              }
            />

            <Route
              path="/edit_operator/:id_operator"
              element={
                <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                  <NewOper />  {/* mismo form en modo edición */}
                </PrivateRoute>
              }
            />


            {/* ---------------------Shifnt List-----------------------*/}
            <Route path="/shift_report" element={<ShiftReport />} />


            {/*------------------OEE------------------------*/}
            <Route
              path="/oee_rep"
              element={
                <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                  <Oee1 />
                </PrivateRoute>
              }
            />

            {/*------------------ACTIVITY TYPE REPORT-------*/}
            <Route
              path="/activity_type_rep"
              element={
                <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                  <ActivityTypeRep />
                </PrivateRoute>
              }
            />


            {/*------------------HELP CENTER-------------------*/}
            <Route
              path="/help"
              element={
                <PrivateRoute allowedRoles={["Coder", "Administrator", "Operator", "Instalator"]}>
                  <HelpCenter />
                </PrivateRoute>
              }
            />

            {/*------------------SCREENS-----------------------*/}
                        <Route
              path="/screen1"
              element={
                <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                  <Screen1 />
                </PrivateRoute>
              }
            />
            <Route
              path="/screen_total"
              element={
                <PrivateRoute allowedRoles={["Coder", "Administrator"]}>
                  <ScreenTotal />
                </PrivateRoute>
              }
            />


          </Routes>
        </div>
      </Router>
      <Footer /> 
    </>
  );
}

export default App;